import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import type { GetMalwareRevisionReportResponse } from '../../../../shared/types/routes/internalTools/malwareReport';

export const getMalwareReportsPagedQueryKey = (page: number, pageSize: number): QueryKey =>
  ['malware', 'reports', { page, pageSize }];

function fetchMalwareReportsPage(page: number, pageSize: number) {
  return get<GetMalwareRevisionReportResponse>(`/api/internal-tools/malware`, false, {
    pageSize,
    page,
  });
}

/**
 * Hook for fetching malware reports with pagination.
 * @param page - The page number to fetch (1-based).
 * @param pageSize - The number of reports to fetch per page.
 * @returns A query for malware reports.
 */
export default function useGetMalwareReports(page = 1, pageSize = 10) {
  return useQuery<GetMalwareRevisionReportResponse>({
    queryKey: getMalwareReportsPagedQueryKey(page, pageSize),
    queryFn: () => fetchMalwareReportsPage(page, pageSize),
  });
}
